























import {
  DashboardService,
} from "@/services/dashboard.service";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";

@Component({
})
export default class ClientesQueNaoRenovaramCard extends Vue {
  totalCadastros: number | null = null;
  loading = false;
  quantidadeDeClientesQueNaoRenovaram?: number = 0;

  @Prop({required: true}) readonly data!: string;

  @Watch("data", {immediate: true}) 
  async onDataChange(val: string) {
    if (val) {
      this.loading = true;
      this.quantidadeDeClientesQueNaoRenovaram = await DashboardService.clientesQueNaoRenovaram(
        val
      ).finally(() => (this.loading = false)
      );
    }
  }
}
